import { useInfiniteQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { portalNotificationsQueryKeys } from './query-keys';
import {
  fetchPortalNotifications,
  PORTAL_NOTIFICATIONS_PAGE_SIZE,
} from '../services/notifications';

export const usePortalNotificationsInfiniteQuery = (options = {}) => {
  const { userRole } = useAuth();
  const { enabled = true, limit = PORTAL_NOTIFICATIONS_PAGE_SIZE } = options;

  return useInfiniteQuery({
    queryKey: portalNotificationsQueryKeys.infinite(userRole, limit),
    enabled: enabled && Boolean(userRole),
    initialPageParam: 1,
    queryFn: async ({ pageParam }) => {
      const page = typeof pageParam === 'number' && pageParam > 0 ? pageParam : 1;
      const result = await fetchPortalNotifications({ limit, page, userRole });
      if (!result.success) {
        throw new Error(result.message || 'Failed to load notifications');
      }
      return result;
    },
    getNextPageParam: (lastPage) => {
      if (!lastPage.hasMore) {
        return undefined;
      }
      return (lastPage.page ?? 1) + 1;
    },
    refetchOnWindowFocus: true,
  });
};
